export const SWITCH_ACCOUNT_DONE = 'SWITCH_ACCOUNT_DONE';
//# sourceMappingURL=actionTypes.js.map